import MyDivider from "src/components/layout/MyDivider";

import PropTypes from "prop-types";

export default function TilausRowWrapper(props) {
  const showChildren = props.show === false ? false : true;
  const noPrint = props.noPrint === true ? true : false;
  if (!showChildren) return <></>;
  return (
    <div className={noPrint ? "noPrint" : ""} style={{ width: "100%" }}>
      <div
        style={{
          paddingTop: "3px",
          paddingBottom: "3px",
          margin: "0px",
          width: "100%",
        }}>
        {props.children}
      </div>
      {props.noDivider == null && <MyDivider />}
    </div>
  );
}

TilausRowWrapper.propTypes = {
  show: PropTypes.bool,
  noDivider: PropTypes.bool,
  children: PropTypes.node,
  noPrint: PropTypes.bool,
};
